import React from 'react';
// material ui components
import { styled } from '@mui/material/styles';
import { Hidden } from '@mui/material';
// header componenets
import HeaderComponent from './header/Header.component';

const PageWrapper = styled('div')(({ theme }) => ({
    padding: '0',
    minHeight: '100vh',
    background: theme.gradients.body,
    borderTopLeftRadius: '30px',
    borderBottomLeftRadius: '30px',
}));

const AppMain = styled('div')({
    backgroundColor: '#FFFFFF',
    paddingLeft: '174px',
});

const MainLayoutComponent = ({ children }) => {
    return (
        <>
            <Hidden lgDown>
                <AppMain>
                    <PageWrapper>
                        <HeaderComponent />
                        {children}
                    </PageWrapper>
                </AppMain>
            </Hidden>
            <Hidden lgUp>
                <PageWrapper>
                    <HeaderComponent />
                    {children}
                </PageWrapper>
            </Hidden>
        </>
    );
};

export default MainLayoutComponent;
